import React from 'react';
import { Button, List, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import ContactSidebarItem from '../ContactSidebarItem';

const SidebarList = ({
    contacts,
    contactsLoading,
    selectedContactId,
    testConversation,
    conversationByContactId,
    hoveredContactId,
    setHoveredContactId,
    isMobile,
    isDarkMode,
    t,
    onAddContact,
    onSelectContact,
    onDeleteContact
}) => {
    const listThemeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        selectedBackground: isDarkMode ? '#183a61' : '#e6f7ff',
        hoverBackground: isDarkMode ? '#2a2a2a' : '#f5f5f5',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)'
    };

    return (
        <div className="agent-test-sidebar-list" style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            <div style={{ padding: 8 }}>
                <Button
                    icon={<PlusOutlined />}
                    type={isDarkMode ? 'primary' : 'default'}
                    ghost={false}
                    block
                    style={{ marginBottom: 12 }}
                    onClick={onAddContact}
                >
                    {t('add_contact')}
                </Button>
            </div>

            {contactsLoading && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                    <Spin size="small" />
                </div>
            )}

            <List
                style={{ overflow: 'auto', padding: isMobile ? '4px 0' : '8px 0', background: listThemeColors.background, flex: 1, minHeight: 0 }}
                dataSource={contacts}
                locale={{ emptyText: t('no_contacts') }}
                renderItem={(contact) => {
                    const isActive = contact?.id && contact.id === selectedContactId;
                    const bgColor = isActive
                        ? listThemeColors.selectedBackground
                        : (hoveredContactId === contact?.id ? listThemeColors.hoverBackground : listThemeColors.background);
                    const conversation = isActive
                        ? testConversation
                        : (contact?.id ? conversationByContactId?.[contact.id] : null);

                    return (
                        <ContactSidebarItem
                            contact={contact}
                            conversation={conversation}
                            isActive={isActive}
                            isMobile={isMobile}
                            isDarkMode={isDarkMode}
                            t={t}
                            listThemeColors={listThemeColors}
                            bgColor={bgColor}
                            hoveredContactId={hoveredContactId}
                            setHoveredContactId={setHoveredContactId}
                            onSelect={() => onSelectContact(contact)}
                            onDelete={() => onDeleteContact(contact)}
                        />
                    );
                }}
            />
        </div>
    );
};

export default SidebarList;













